import { toDrawerOption } from "@/navigation/activitiesRegistry";
import { ROLES_MIEMBRO_DIRECTIVA } from "@/utils/courseRoles";
import { canManageElectivos, canManageWithdrawalBoard, canValidateWithdrawalArrival, canViewWithdrawalDayList, isDriverCourse, isGateGuardCourse, isInspectorCourse, } from "@/utils/funcionarios";
import { canAccessGuardianWithdrawals, canAccessKioskModule, isAlumnosCourse, isCpaCourse, isCpaDirectiva, isFuncionariosCourse, isKioskCourse, } from "@/utils/parseCourseCode";
const esMiembroDirectiva = (roles) => ROLES_MIEMBRO_DIRECTIVA.some((rol) => roles.includes(rol));
const filtrarOpcionesPorTipoTesoreria = (opciones, tipoTesoreria) => opciones.filter((opcion) => {
    if (opcion.requiresTipoTesoreria === undefined)
        return true;
    if (opcion.requiresTipoTesoreria === "")
        return !tipoTesoreria;
    return opcion.requiresTipoTesoreria === tipoTesoreria;
});
const gruposBase = () => [
    {
        nombre: "Mis pagos",
        opciones: [
            toDrawerOption("treasury-register-payment"),
            toDrawerOption("treasury-my-payments"),
            toDrawerOption("treasury-my-debts"),
        ],
    },
    {
        nombre: "Grupo",
        opciones: [
            toDrawerOption("users-group"),
            toDrawerOption("tasks"),
            toDrawerOption("treasury-funds"),
        ],
    },
];
const obtenerGrupoActividades = (roles, cursoData) => {
    if (isKioskCourse(cursoData)) {
        return {
            nombre: "Actividades",
            opciones: [toDrawerOption("kiosk")],
        };
    }
    const opciones = [];
    if (roles?.includes("treasurer")) {
        opciones.push(toDrawerOption("manage-sales"));
        opciones.push(toDrawerOption("manage-donations"));
    }
    if (!isCpaCourse(cursoData)) {
        opciones.push(toDrawerOption("sales"));
        opciones.push(toDrawerOption("donations"));
    }
    if (canAccessKioskModule(cursoData)) {
        opciones.push(toDrawerOption("kiosk"));
    }
    if (canAccessGuardianWithdrawals(cursoData)) {
        opciones.push(toDrawerOption("guardian-withdrawals"));
    }
    if (cursoData &&
        !isFuncionariosCourse(cursoData) &&
        !isKioskCourse(cursoData)) {
        opciones.push(toDrawerOption("transport"));
        opciones.push(toDrawerOption("classifieds"));
    }
    if (isCpaDirectiva(cursoData)) {
        opciones.push(toDrawerOption("tournaments"));
        opciones.push(toDrawerOption("fairs"));
        opciones.push(toDrawerOption("suppliers"));
    }
    return { nombre: "Actividades", opciones };
};
const obtenerGrupoRetirosEscolares = (cursoData, isAndroid) => {
    if (!isFuncionariosCourse(cursoData))
        return null;
    if (isDriverCourse(cursoData))
        return null;
    const opciones = [];
    if (canValidateWithdrawalArrival(cursoData)) {
        opciones.push(toDrawerOption("staff-validate-withdrawal"));
        if (isAndroid) {
            opciones.push(toDrawerOption("staff-scan-barcode"));
        }
    }
    if (isGateGuardCourse(cursoData) ||
        (canViewWithdrawalDayList(cursoData) &&
            !canManageWithdrawalBoard(cursoData))) {
        opciones.push(toDrawerOption("staff-day-withdrawals"));
    }
    if (canManageWithdrawalBoard(cursoData)) {
        opciones.push(toDrawerOption("staff-withdrawal-board"));
    }
    if (opciones.length === 0)
        return null;
    return { nombre: "Retiros escolares", opciones };
};
const obtenerGrupoValidacionIngreso = (cursoData) => {
    if (!isInspectorCourse(cursoData))
        return null;
    return {
        nombre: "Validación de ingreso",
        opciones: [
            toDrawerOption("staff-validate-entry"),
            toDrawerOption("staff-inspect-guardians"),
            toDrawerOption("staff-qr-logs"),
        ],
    };
};
const obtenerGrupoTransporte = (cursoData) => {
    if (!isDriverCourse(cursoData))
        return null;
    return {
        nombre: "Transporte",
        opciones: [
            toDrawerOption("driver-panel"),
            toDrawerOption("driver-trip"),
            toDrawerOption("driver-routes"),
            toDrawerOption("driver-requests"),
        ],
    };
};
const extrasOpcionesDirectiva = (roles, enCpa) => [
    ...(enCpa ? [] : [toDrawerOption("association-link")]),
    ...(esMiembroDirectiva(roles) ? [toDrawerOption("edit-board")] : []),
];
const obtenerGruposAdministrativos = (roles, cursoData) => {
    if (!roles || roles.length === 0)
        return [];
    const enCpa = isCpaCourse(cursoData);
    const opcionGestionMiembros = enCpa
        ? toDrawerOption("courses-boards", {
            texto: "Gestionar cursos",
            icono: "bi bi-journal-bookmark",
        })
        : toDrawerOption("users-manage");
    const grupos = [];
    const tieneTesorero = roles.includes("treasurer");
    const tienePresidente = roles.includes("president");
    const tieneSecretario = roles.includes("secretary");
    const tieneVicepresidente = roles.includes("vicepresident");
    const tieneRolDirectivaPrincipal = tieneTesorero ||
        tienePresidente ||
        tieneSecretario ||
        tieneVicepresidente;
    const opcionesGestion = [
        opcionGestionMiembros,
        toDrawerOption("commissions"),
        toDrawerOption("surveys"),
        toDrawerOption(enCpa ? "cpa-mass-email" : "mass-email", {
            texto: "Email masivo",
            icono: "bi bi-envelope-paper",
        }),
        toDrawerOption("sent-notifications"),
        ...extrasOpcionesDirectiva(roles, enCpa),
    ];
    if (tieneTesorero) {
        grupos.push({
            nombre: "Administrativo: Tesorero",
            opciones: [
                toDrawerOption("treasury-register-expense"),
                toDrawerOption("treasury-register-income"),
            ],
        });
        grupos.push({
            nombre: "Extras",
            opciones: opcionesGestion,
        });
        return grupos;
    }
    if (tienePresidente || tieneVicepresidente) {
        grupos.push({
            nombre: tienePresidente
                ? "Administrativo: Presidente"
                : "Administrativo: Vicepresidente",
            opciones: opcionesGestion,
        });
    }
    if (tieneSecretario && !tienePresidente && !tieneVicepresidente) {
        grupos.push({
            nombre: "Administrativo: Secretario",
            opciones: opcionesGestion,
        });
    }
    if (esMiembroDirectiva(roles) && !tieneRolDirectivaPrincipal) {
        grupos.push({
            nombre: "Directiva",
            opciones: [toDrawerOption("edit-board")],
        });
    }
    return grupos;
};
const RUTAS_OMITIDAS_BOTTOM_NAV = new Set([
    "tareas-mis",
    "ver-usuarios-grupo",
    "gestion-centro-costos",
    "ver-usuarios",
    "notificaciones-email-list",
    "crear-link-asociacion-curso",
    "comisiones-list",
    "encuestas-list",
    "mis-retiros",
]);
export const buildCourseDrawer = (ctx) => {
    const { roles, treasuryType, cursoData, bottomNavActive, isAndroid } = ctx;
    const gruposAdmin = obtenerGruposAdministrativos(roles, cursoData);
    const grupoActividades = obtenerGrupoActividades(roles, cursoData);
    const grupoRetiros = obtenerGrupoRetirosEscolares(cursoData, isAndroid);
    const grupoTransporte = obtenerGrupoTransporte(cursoData);
    const grupoValidacionIngreso = obtenerGrupoValidacionIngreso(cursoData);
    let grupos = bottomNavActive
        ? [...gruposBase(), ...gruposAdmin]
        : [...gruposBase(), grupoActividades, ...gruposAdmin];
    if (grupoRetiros)
        grupos = [...grupos, grupoRetiros];
    if (grupoTransporte)
        grupos = [...grupos, grupoTransporte];
    if (isFuncionariosCourse(cursoData)) {
        const grupoElectivos = canManageElectivos(cursoData)
            ? [{ nombre: "Académico", opciones: [toDrawerOption("asignaciones")] }]
            : [];
        if (grupoTransporte) {
            grupos = [grupoTransporte];
        }
        else {
            grupos = [
                ...(grupoValidacionIngreso ? [grupoValidacionIngreso] : []),
                ...(grupoRetiros ? [grupoRetiros] : []),
                ...grupoElectivos,
            ];
        }
    }
    if (isAlumnosCourse(cursoData)) {
        grupos = [{ nombre: "Asignaciones", opciones: [toDrawerOption("asignaciones")] }];
    }
    if (isKioskCourse(cursoData)) {
        grupos = bottomNavActive
            ? [...gruposBase()]
            : [...gruposBase(), grupoActividades];
    }
    if (bottomNavActive) {
        grupos = grupos
            .filter((grupo) => grupo.nombre !== "Administrativo: Tesorero")
            .map((grupo) => ({
            ...grupo,
            opciones: (grupo.opciones || []).filter((opcion) => !RUTAS_OMITIDAS_BOTTOM_NAV.has(opcion.ruta || "")),
        }))
            .filter((grupo) => (grupo.opciones || []).length > 0);
    }
    return grupos
        .map((grupo) => ({
        ...grupo,
        opciones: filtrarOpcionesPorTipoTesoreria(grupo.opciones, treasuryType),
    }))
        .filter((grupo) => (grupo.opciones || []).length > 0);
};
